<template>
  <div v-if="clientData" class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-12">
          <i class="icon-people" style="margin-right: 0.5rem"></i>
          {{
            clientData.prospect && clientData.prospect.isProspect
              ? "Prospect"
              : "Client"
          }}: {{ clientData.email }} - N°
          {{ clientData.matricule }}
          {{
            clientData.prospect && !!clientData.prospect.lastFormFilledAt
              ? "(lead web)"
              : ""
          }}
        </div>
      </div>
      <div class="row" v-if="!clientData.deletedAt">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-sm btn-danger float-left mt-1"
            v-if="
              clientData.prospect &&
              clientData.prospect.isProspect &&
              hasPermission($store.state.user, 'PROSPECTS_DELETE')
            "
            @click="removeClient()"
          >
            Supprimer
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger float-left mt-1"
            v-else-if="hasPermission($store.state.user, 'CLIENTS_DELETE')"
            @click="removeClient()"
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>

    <div class="card-block">
      <dl class="row">
        <dt class="col-sm-4">Email de contact</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.contactEmail"
            size="mini"
            @change="editClient('contactEmail', $event)"
            @blur="handleBlur"
            :class="{
              'has-error': !clientData.contactEmail && !isCollectivity,
            }"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.contactEmail }}</span>
        </dd>
        <dt class="col-sm-4">Prénom</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.firstName"
            size="mini"
            @change="editClient('firstName', $event)"
            @blur="handleBlur"
            :class="{
              'has-error': !clientData.firstName && !isCollectivity,
            }"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.firstName }}</span>
        </dd>
        <dt class="col-sm-4">Nom</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.lastName"
            size="mini"
            @change="editClient('lastName', $event)"
            @blur="handleBlur"
            :class="{
              'has-error': !clientData.lastName && !isCollectivity,
            }"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.lastName }}</span>
        </dd>
        <dt class="col-sm-4">Société</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.company"
            size="mini"
            :class="{
              'has-error':
                !clientData.company &&
                (clientData.isB2B || clientData.marketEstablishment),
            }"
            @change="editClient('company', $event)"
            @blur="handleBlur"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.company }}</span>
        </dd>
        <dt class="col-sm-4">Client B2B</dt>
        <dd class="col-sm-8">
          <el-switch
            v-model="clientData.isB2B"
            active-text="Oui"
            inactive-text="Non"
            size="mini"
            @change="editClient('isB2B', $event)"
            :disabled="!checkPermission"
          />
        </dd>
        <dt v-if="clientData.isB2B" class="col-sm-4">Établissement marchés</dt>
        <dd v-if="clientData.isB2B" class="col-sm-8">
          <el-switch
            v-model="clientData.marketEstablishment"
            active-text="Oui"
            inactive-text="Non"
            size="mini"
            @change="editClient('marketEstablishment', $event)"
            :disabled="!checkPermission"
          />
        </dd>
        <dt class="col-sm-4">Genre</dt>
        <dd class="col-sm-8">
          <el-select
            v-model="clientData.gender"
            size="mini"
            @change="editClient('gender', $event)"
            @blur="handleBlur"
            :class="{
              'has-error': !clientData.gender && !isCollectivity,
            }"
            :disabled="!checkPermission"
          >
            <el-option value="Homme" />
            <el-option value="Femme" />
          </el-select>
        </dd>
        <dt class="col-sm-4">Préférence</dt>
        <dd class="col-sm-8">
          <el-select
            v-model="clientData.preferedCoachGender"
            size="mini"
            @change="editClient('preferedCoachGender', $event)"
            :disabled="!checkPermission"
          >
            <el-option value="Homme" />
            <el-option value="Femme" />
            <el-option value="Peu importe" />
          </el-select>
        </dd>
        <dt v-if="clientData.strictCoachGender" class="col-sm-4">
          Préférence stricte
        </dt>
        <dd v-if="clientData.strictCoachGender" class="col-sm-8">
          <el-input
            v-model="clientData.strictCoachGender"
            size="mini"
            @change="editClient('strictCoachGender', $event)"
            v-if="checkPermission"
          />
        </dd>
        <dt class="col-sm-4">Téléphone</dt>
        <dd class="col-sm-8">
          <PhoneNumberInput
            v-if="checkPermission"
            :phone-number="clientData.phone"
            :phone-code="clientData.phoneCode"
            size="mini"
            copy
            :required="!clientData.isB2B"
            @changeNumber="editClient('phone', $event)"
            @changeCode="editClient('phoneCode', $event)"
            @checkField="handleBlur"
          />
          <span v-else
            ><span v-if="clientData.phoneCode"
              >({{ clientData.phoneCode }}) </span
            >{{ clientData.phone }}</span
          >
        </dd>
        <dt class="col-sm-4">Date de naissance</dt>
        <dd class="col-sm-8">
          <el-date-picker
            v-model="clientData.birthDate"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            type="date"
            size="small"
            :class="{
              'has-error': !clientData.birthDate && !isCollectivity,
            }"
            @change="editClient('birthDate', $event)"
            @blur="handleBlur"
            v-if="checkPermission"
          />
          <span v-else>{{ formatDate(client.birthDate) }}</span>
        </dd>
        <dt class="col-sm-4">Préférence de contact</dt>
        <dd class="col-sm-8">
          <multiselect
            v-model="clientData.preferredContactMethod"
            :options="preferredContactMethodOptions"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @input="editClient('preferredContactMethod', $event)"
            placeholder="Choisir"
            class="custom-multiselect"
            :disabled="!checkPermission"
          />
        </dd>
        <dt class="col-sm-4">Horaire pour rappeler</dt>
        <dd class="col-sm-8">
          <multiselect
            v-model="clientData.bestTimeToCall"
            :options="bestTimeToCallOptions"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @input="editClient('bestTimeToCall', $event)"
            placeholder="Choisir"
            class="custom-multiselect"
            :disabled="!checkPermission"
          />
        </dd>
        <dt class="col-sm-4">Lieux des séances</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.preferedPlace"
            size="mini"
            @change="editClient('preferedPlace', $event)"
            @blur="handleBlur"
            :class="{
              'has-error': !clientData.preferedPlace && !isCollectivity,
            }"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.preferedPlace }}</span>
        </dd>
        <dt class="col-sm-4">Personnes / séances</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.preferedSession"
            size="mini"
            @change="editClient('preferedSession', $event)"
            @blur="handleBlur"
            :class="{
              'has-error': !clientData.preferedSession && !isCollectivity,
            }"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.preferedSession }}</span>
        </dd>
        <dt class="col-sm-4">Pack souhaité</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.interestedPack"
            size="mini"
            @change="editClient('interestedPack', $event)"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.interestedPack }}</span>
        </dd>
        <dt class="col-sm-4">Découvert par</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="clientData.discoveredBy"
            size="mini"
            @change="editClient('discoveredBy', $event)"
            v-if="checkPermission"
          />
          <span v-else>{{ clientData.discoveredBy }}</span>
        </dd>
        <dt class="col-sm-4">Concepts</dt>
        <dd class="col-sm-8">
          <multiselect
            v-model="clientData.concepts"
            :options="concepts"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            @input="editClient('concepts', $event)"
            label="name"
            track-by="name"
            placeholder="Choisir"
            class="custom-multiselect"
            :disabled="!checkPermission"
          >
          </multiselect>
        </dd>

        <div class="col-sm-12">
          <hr />
        </div>

        <dt v-if="!isCollectivity" class="col-sm-4">Application</dt>
        <dd v-if="!isCollectivity" class="col-sm-8">
          <button
            class="btn btn-sm btn-primary"
            v-if="clientData.devices.length === 0"
            @click="sendEmailDownloadMobileApp"
          >
            <i class="icon-screen-smartphone"></i> Envoi d'email pour
            télécharger l'application
          </button>

          <span v-else>
            Dernière utilisation le
            {{ formatDate(clientData.devices[0].lastUsedAt) }}
            - Version {{ clientData.devices[0].clientAppVersion }}
          </span>
        </dd>

        <dt class="col-sm-4">
          Notification Email

          <i
            class="fa fa-info-circle ml-05"
            v-tooltip="{
              content:
                'Le client reçoit ou non les emails concernant la validation des séances etc.',
              placement: 'right',
            }"
          ></i>
        </dt>
        <dd class="col-sm-8">
          <el-switch
            v-model="clientData.emailNotification"
            active-text="Oui"
            inactive-text="Non"
            size="mini"
            @change="editClient('emailNotification', $event)"
            :disabled="!checkPermission"
          />
        </dd>

        <dt class="col-sm-4">
          Offre Email/SMS
          <i
            class="fa fa-info-circle ml-05"
            v-tooltip="{
              content:
                'Important en cas d\'export pour la campagne de newsletter.',
              placement: 'right',
            }"
          ></i>
        </dt>
        <dd class="col-sm-8">
          <el-switch
            v-model="clientData.newsletter"
            active-text="EMAIL"
            inactive-text="Non"
            size="mini"
            @change="editClient('newsletter', $event)"
            :disabled="!checkPermission"
          />

          <el-switch
            class="ml-2"
            v-model="clientData.smsBlacklisted"
            active-text="SMS"
            inactive-text="Non"
            size="mini"
            @change="editClient('smsBlacklisted', $event)"
            :disabled="!checkPermission"
          />
        </dd>
        <dt class="col-sm-4">Avis Google</dt>
        <dd class="col-sm-8">
          <el-switch
            v-model="clientData.googleNotice"
            active-text="Oui"
            inactive-text="Non"
            size="mini"
            @change="editClient('googleNotice', $event)"
            :disabled="!checkPermission"
          />
          <span v-if="clientData.googleNoticeSince" class="text-muted ml-1">
            Avis posté le {{ formatDate(clientData.googleNoticeSince) }}
          </span>
        </dd>
        <dt class="col-sm-4">Avis Trustpilot</dt>
        <dd class="col-sm-8">
          <el-switch
            v-model="clientData.trustpilotNotice"
            active-text="Oui"
            inactive-text="Non"
            size="mini"
            @change="editClient('trustpilotNotice', $event)"
            :disabled="!checkPermission"
          />

          <span v-if="clientData.trustpilotNoticeSince" class="text-muted ml-1">
            Avis posté le {{ formatDate(clientData.trustpilotNoticeSince) }}
          </span>
        </dd>
        <dt class="col-sm-4" v-if="checkPermission">
          Mot de passe
          <i
            class="fa fa-info-circle ml-05"
            v-tooltip="{
              content: 'Pour l\'accès à l\'application client',
              placement: 'right',
            }"
          ></i>
        </dt>
        <dd class="col-sm-8" v-if="checkPermission">
          <button
            type="button"
            class="btn btn-primary"
            @click="sendLostPasswordEmail"
          >
            Email "mot de passe oublié"
          </button>
        </dd>
        <dt class="col-sm-4">
          Coach prospecté (Scrapping)

          <i
            class="fa fa-info-circle ml-05"
            v-tooltip="{
              content:
                'Le coach de se client à été prospecté spécifiquement pour lui, car aucun autre n\'était présent dans la zone.',
              placement: 'right',
            }"
          ></i>
        </dt>
        <dd class="col-sm-8">
          <el-switch
            :value="clientData.prospectedCoach"
            active-text="oui"
            inactive-text="non"
            size="mini"
            @change="toggleProspectedCoach"
            :disabled="!checkPermission"
          />
          <span class="ml-1" v-if="clientData.prospectedCoach">
            Prospecté le {{ formatDate(clientData.prospectedAt) }} par
            {{ clientData.prospectedBy }}</span
          >
        </dd>
        <dt class="col-sm-4">Compte créé</dt>
        <dd class="col-sm-8">{{ formatDate(clientData.createdAt) }}</dd>
        <dt class="col-sm-4" v-if="ordersPrice">Total des commandes</dt>
        <dd class="col-sm-8" v-if="ordersPrice">
          {{ formatPrice(ordersPrice) }}
        </dd>
        <dt class="col-sm-4">Coachs</dt>
        <dd class="col-sm-8">
          <div
            class="col-sm-12 p-0"
            v-for="(coach, index) in clientData.coachs"
            :key="index"
          >
            <a :href="coachHref(coach.id)" target="_blank">
              {{ coach.coach.name }}
            </a>
            <span v-if="coach.coach.phone">
              {{ coach.coach.phone }}
            </span>
            <span
              v-if="coach.lastSessionValidatedAt"
              v-tooltip="{
                content: `Dernière séance validée: ${formatDate(
                  coach.lastSessionValidatedAt,
                )}`,
                placement: 'right',
              }"
              class="text-muted ml-05"
            >
              <i class="fa fa-check"></i>
              {{ formatDate(coach.lastSessionValidatedAt) }}
            </span>
          </div>
        </dd>
        <dt class="col-sm-4" v-if="payers.length > 0">Payeur</dt>
        <dd class="col-sm-8" v-if="payers.length > 0">
          <p class="m-0" v-for="(payer, index) in payers" :key="index">
            {{ payer }}
          </p>
        </dd>
        <dt class="col-sm-4">Fréquence</dt>
        <dd class="col-sm-8" v-if="orders.length > 0">
          {{ averageClientFrequency(orders) || "-" }}
        </dd>
        <dd class="col-sm-8" v-else>
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </dd>
      </dl>

      <div class="mb-1">
        <button
          type="button"
          class="btn btn-secondary"
          v-if="dateLastCompletedSession"
        >
          Séance validée
          {{ dateLastCompletedSession.format("DD.MM.YYYY") }}
        </button>
        <button
          type="button"
          class="btn btn-info"
          v-if="dateNextScheduledSession"
        >
          Programmé le {{ dateNextScheduledSession.format("DD.MM.YYYY") }}
        </button>
        <button
          type="button"
          class="btn btn-danger"
          v-if="dateLastCompletedSession && !dateNextScheduledSession"
        >
          Inactif depuis {{ daysInactive }} jours
        </button>
      </div>

      <div>
        <button
          type="button"
          class="btn btn-secondary"
          @click="openModalBillingInformations"
        >
          <i class="icon-doc"></i> Informations de facturation
        </button>
      </div>
    </div>

    <BillingInformations
      :show="showModalBillingInformations"
      :client="clientData"
      @close="closeModalBillingInformations"
      @editOrderDescription="editOrderDescription"
      @deleteOrderDescription="deleteOrderDescription"
      @addOrderDescription="addOrderDescription"
    />

    <ModalProspectedCoach
      :visible="showModalProspectedCoach"
      :close="closeProspectedCoach"
      :updateClient="addedProspectedCoach"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import Multiselect from "vue-multiselect";
import FrequencyMixin from "@/mixin/FrequencyMixin";
import PhoneNumberInput from "@/components/utils/PhoneNumberInput.vue";
import ModalProspectedCoach from "@/components/coach-manager/scrapping/prospected-coach/ModalProspectedCoach.vue";
import BillingInformations from "@/components/modal/BillingInformations.vue";

export default {
  components: {
    Multiselect,
    PhoneNumberInput,
    ModalProspectedCoach,
    BillingInformations,
  },

  mixins: [FrequencyMixin],

  props: {
    client: {
      type: Object,
      required: true,
    },

    orders: {
      type: Array,
      default: () => [],
    },

    sessions: {
      type: Array,
      default: () => [],
    },

    groups: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      clientData: undefined,
      showBilling: false,
      showModalProspectedCoach: false,
      showModalBillingInformations: false,
    };
  },

  computed: {
    ...mapState({
      concepts: (state) => state.concepts,
    }),

    ...mapGetters({
      preferredContactMethodOptions: "getPreferredContactMethodOptions",
      bestTimeToCallOptions: "getBestTimeToCallOptions",
    }),

    isCollectivity() {
      return this.clientData.isB2B || this.clientData.marketEstablishment;
    },

    payers() {
      const payers = [];

      if (this.client.payments) {
        for (const payment of this.client.payments) {
          if (payment.payer && !payers.includes(payment.payer)) {
            payers.push(payment.payer);
          }
        }
      }

      return payers;
    },

    ordersPrice() {
      let price = 0;

      this.orders.forEach((order) => {
        if (order.status === "refunded") {
          price -= order.price;
        } else {
          price += order.price;
        }
      });

      return price;
    },

    dateLastCompletedSession() {
      let dateCurrent = moment();
      let date = null;

      let sessions = this.sessions.filter(
        (s) => !!s.scheduledAt && s.completed,
      );

      sessions.forEach((s) => {
        let scheduledAt = moment(s.scheduledAt);

        if (
          scheduledAt <= dateCurrent &&
          (date == null || scheduledAt > date)
        ) {
          date = scheduledAt;
        }
      });

      return date;
    },

    daysInactive() {
      if (!this.dateLastCompletedSession) return null;

      return moment().diff(this.dateLastCompletedSession, "days");
    },

    dateNextScheduledSession() {
      let dateCurrent = moment();
      let date = null;

      let sessions = this.sessions.filter((s) => !!s.scheduledAt);

      sessions.forEach((s) => {
        let scheduledAt = moment(s.scheduledAt);

        if (
          scheduledAt >= dateCurrent &&
          (date == null || scheduledAt < date)
        ) {
          date = scheduledAt;
        }
      });

      return date;
    },

    checkPermission() {
      return (
        this.hasPermission(this.$store.state.user, "CLIENTS_WRITE") &&
        !this.client.deletedAt
      );
    },
  },

  watch: {
    client: {
      handler() {
        this.clientData = this.client;
      },
      deep: true,
    },
  },

  created() {
    this.clientData = this.client;
  },

  methods: {
    openModalBillingInformations() {
      this.showModalBillingInformations = true;
    },

    closeModalBillingInformations() {
      this.showModalBillingInformations = false;
    },

    editOrderDescription(template) {
      this.$emit("editOrderDescription", template);
    },

    deleteOrderDescription(descriptionId) {
      this.$emit("deleteOrderDescription", descriptionId);
    },

    addOrderDescription(template) {
      this.$emit("addOrderDescription", template);
    },

    toastError() {
      this.$errorToast(
        "Veuillez remplir les champs obligatoires (entourés en rouge)",
      );
    },

    handleBlur(phone) {
      let fieldsNotValid = true;

      if (this.isCollectivity) {
        fieldsNotValid = !!this.clientData.company;
      } else {
        const fieldsToValidate = [
          !!this.clientData.contactEmail,
          !!this.clientData.firstName,
          !!this.clientData.lastName,
          !!this.clientData.gender,
          phone,
          !!this.clientData.birthDate,
          !!this.clientData.preferedPlace,
          !!this.clientData.preferedSession,
        ];

        fieldsNotValid = fieldsToValidate.find((field) => field === false);
      }

      if (fieldsNotValid === false) {
        this.$errorToast(
          "Veuillez remplir les champs obligatoires (entourés en rouge)",
        );
      }
    },

    toggleProspectedCoach() {
      if (!this.clientData.prospectedCoach) {
        this.showModalProspectedCoach = true;
      } else {
        this.addedProspectedCoach({
          prospectedBy: null,
          prospectedAt: null,
          prospectedCoach: false,
        });
      }
    },

    closeProspectedCoach() {
      this.showModalProspectedCoach = false;
    },

    async addedProspectedCoach(updateData) {
      try {
        const { data } = await this.$api.patch(
          `/clients/${this.client.id}/coach-manager`,
          {
            prospectedBy: updateData.prospectedBy,
            prospectedAt: updateData.prospectedAt,
            prospectedCoach: updateData.prospectedCoach,
          },
        );

        this.clientData.prospectedCoach = data.prospectedCoach;
        this.clientData.prospectedBy = data.prospectedBy;
        this.clientData.prospectedAt = data.prospectedAt;
        this.$successToast(data.message);
      } catch (e) {
        this.$errorToast("La mise à jour du client a échoué");
      }
    },

    editClient(name, value) {
      if (name === "isB2B" && !value) {
        this.clientData.marketEstablishment = false;
      }

      this.$emit("edit", { name, value });
    },

    removeClient() {
      this.$confirm({
        message:
          "Attention, cette action est irreversible ! Le client sera anonymisé et vous ne retrouverez plus ses informations dans les commandes existantes.",
        onConfirm: async () => {
          try {
            await this.$api.delete("/clients", {
              data: {
                email: this.client.email,
              },
            });

            this.$router.push({
              name: "clients",
            });
          } catch (e) {
            console.warn(e);
          }
        },
      });
    },

    sendLostPasswordEmail() {
      this.$confirm({
        message: `Attention, cela va envoyer un email à l'adresse suivante : ${this.clientData.usedEmail}`,
        onConfirm: async () => {
          try {
            await this.$api.post("/client-app/auth/reset-password", {
              email: this.clientData.email,
            });

            this.$successToast("Email envoyé");
          } catch (e) {
            console.warn(e);
          }
        },
      });
    },

    coachHref(id) {
      const route = this.$router.resolve({
        name: "user-details",
        params: {
          id,
        },
      });

      return route.href;
    },

    stripeCustomer(customerId) {
      return "https://dashboard.stripe.com/customers/" + customerId;
    },

    changeBillingPhone(phone) {
      this.clientData.billing = {
        ...this.clientData.billing,
        phone,
      };
    },

    sendEmailDownloadMobileApp() {
      this.$confirm({
        message: `Cela va envoyer un email à l'adresse suivante : ${this.clientData.contactEmail}`,
        onConfirm: async () => {
          try {
            await this.$api.post("/clients/send-email-download-app", {
              email: this.clientData.email,
            });

            this.$successToast("Email envoyé");
          } catch (e) {
            this.$errorToast("Impossible d'envoyer l'email");
          }
        },
      });
    },
  },
};
</script>
